import { createRouter, createWebHistory } from "vue-router";
import LandingPage from "../views/MainHomePages/LandingPage.vue";
import LoginPage from "../views/MainHomePages/LoginPage.vue";

const routes = [
  {
    path: "/",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/LandingPage",
    name: "LandingPage",
    component: LandingPage,
    children: [
      {
        path: "/Organizations",
        name: "Organizations",
        component: () => import("@/views/ChildHomePages/OrganizationsPage.vue"),
      },
      {
        path: "/CreateOrganization",
        name: "CreateOrganization",
        component: () => import("@/views/ChildHomePages/CreateOrganizationPage.vue"),
      },
      {
        path: "/Packages",
        name: "Packages",
        component: () => import("@/views/ChildHomePages/PackagesPage.vue"),
      },
      {
        path: "/Modules",
        name: "Modules",
        component: () => import("@/views/ChildHomePages/ModulesPage.vue"),
      },

      {
        path: "/Countries",
        name: "Countries",
        component: () => import("@/views/ChildHomePages/CountriesPage.vue"),
      },
      {
        path: "/Users",
        name: "Users",
        component: () => import("@/views/ChildHomePages/UsersPage.vue"),
      },
      {
        path: "/AuditLogs",
        name: "AuditLogs",
        component: () => import("@/views/ChildHomePages/AuditLogs.vue"),
      },
      {
        path: "/SipTrunks",
        name: "SipTrunks",
        component: () => import("@/views/ChildHomePages/SipTrunks.vue"),
      },
    ],
  },
];
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
